import { createSelector } from 'reselect'
import { localize, localizeWithVars } from 'helpers/translator/localize'
import productTypes from 'helpers/enums/productTypes'

const productIdSelector = state => state.user.data ? state.user.data.productId : ''
const notificationDataSelector = state => state.user.data && state.user.data.notificationMessage ? state.user.data.notificationMessage.data : ''

const myLibrarySchoolInviteSelector = createSelector(
	[productIdSelector, notificationDataSelector],
	(productId, notificationData) => {
		const newData = { SchoolName: notificationData.newSchool, ProductName: notificationData.newProduct, ayceNames: '' }
		let key = 'importUser_popin_message_changeUserSchool'
		switch (productId) {
			case productTypes.GOLD:
				key = 'importUser_popin_message_changeUserSchool_gold'
				break
			case productTypes.GOLD_PLUS:
				key = 'importUser_popin_message_changeUserSchool_goldPlus'
				break
			case productTypes.DISTRICT:
			case productTypes.SCHOOL:
				if (notificationData.ayceNames) {
					const filteredAyceNames = notificationData.ayceNames.filter(ayceName => !!ayceName)
					newData.ayceNames = filteredAyceNames.join(', ')
					newData.subscriptionLabel = filteredAyceNames.length > 1 ? localize('subscriptions') : localize('subscription')
					key = 'importUser_popin_message_changeUserSchoolWithAyce'
				}
				break
			default:
				break
		}

		const message = localizeWithVars(key, newData)

		return {
			message,
		}
	}
)

export default myLibrarySchoolInviteSelector
